import { Colour, ListItem, useLayout } from '@ukpostbox/frontend-framework';
import { faLineChart } from '@fortawesome/pro-solid-svg-icons/faLineChart';
import { FormatLocaleRelativeStrict } from '@ukpostbox/helpers';
import React from 'react';
import { ActivityTopUpType } from '@ukpostbox/client-data/lib/Types/ClientTypes';
import { useSite } from '../../../_Global/Providers/SiteInterfaceProvider';

function ActivityEventTopUp(item: ActivityTopUpType) {
	const { currentLocale } = useSite();
	const { isTiny, isSmall } = useLayout();

	return (
		<ListItem
			actionLink={{ url: `./manage-account/payment/transactions` }}
			iconContent={{ icon: faLineChart, iconBg: Colour.Success }}
			title={item.message}
			description={isTiny || isSmall ? FormatLocaleRelativeStrict(item.eventDate, currentLocale) : undefined}
			addonRight={
				!isTiny && !isSmall ? { content: FormatLocaleRelativeStrict(item.eventDate, currentLocale) } : undefined
			}
		/>
	);
}

export { ActivityEventTopUp };
